import type {
  ClientEnvironmentListResponse,
  SimpleClientEnvironmentListResponse,
} from '@/types/service/clientEnvironment';

import { baseProtectedApi } from '@/store/baseApi';

export const clientEnvironmentApi = baseProtectedApi.injectEndpoints({
  endpoints: (builder) => ({
    getClientEnvironments: builder.query<ClientEnvironmentListResponse, void>({
      query: () => ({
        url: '/v1/protected/client-environments',
        method: 'GET',
      }),
    }),
    getSimpleClientEnvironments: builder.query<SimpleClientEnvironmentListResponse, void>({
      query: () => ({
        url: '/v1/protected/client-environments/simple',
        method: 'GET',
      }),
    }),
  }),
});

export const { useGetClientEnvironmentsQuery, useGetSimpleClientEnvironmentsQuery } =
  clientEnvironmentApi;
